import { render } from "./ReturnReceipt.vue?vue&type=template&id=3554066d&scoped=true"
import script from "./ReturnReceipt.vue?vue&type=script&lang=js"
export * from "./ReturnReceipt.vue?vue&type=script&lang=js"

import "./ReturnReceipt.vue?vue&type=style&index=0&id=3554066d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3554066d"]])

export default __exports__